import React, {useEffect, useState} from 'react';
import {injectIntl} from 'react-intl';
import axios from 'axios';
import getFormConfig from 'getFormConfig';
import FormField from '@FormComponents/FormField';
import Button from '@FormComponents/Button';
import {pushFindEmployeesEvent} from 'dataLayerHelper';
import {Sha256} from '@aws-crypto/sha256-browser';
import {toHex} from '@aws-sdk/util-hex-encoding';

const SubscribeForm = ({intl, staticContext}) => {
  const [state, setState] = useState({});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [hashedEmail, setHashedEmail] = useState('');

  useEffect(() => {
    if (state.email) {
      const hash = new Sha256();
      hash.update(state.email);
      hash.digest().then((result) => {
        setHashedEmail(toHex(result));
      });
    }
  }, [state]);

  const onChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const renderForm = () => {
    const formTopConfig = getFormConfig()['subscribe_preference'];
    const formBottomConfig = getFormConfig()['subscribe_details'];
    const fieldsTop = formTopConfig.map((field, i) => {
      const {name} = field;
      return (
        <FormField
          state={state}
          setState={setState}
          field={field}
          errors={errors}
          setErrors={setErrors}
          onChange={onChange}
          key={`component-${name}-${i}`} />
      );
    });
    const fieldsBottom = formBottomConfig.map((field, i) => {
      const {name} = field;
      return (
        <FormField
          state={state}
          setState={setState}
          field={field}
          errors={errors}
          setErrors={setErrors}
          onChange={onChange}
          key={`component-${name}-${i}`} />
      );
    });

    const submitSubscribe = (event) => {
      setLoading(true);
      axios.post(`${process.env.REACT_APP_API_PREFIX}/get-callback`, {
        callback: '@Callbacks/employeeAlertsSubscribe',
        currentRoute: {},
        data: state,
      }).then(async (response) => {
        setErrors({});
        setLoading(false);
        let hsObjectId = '';
        await axios.post(`${process.env.REACT_APP_API_PREFIX}/get-callback`, {
          callback: '@Callbacks/getHubspotContact',
          currentRoute: {},
          data: state.email,
        }).then((response) => {
          if (response.data) {
            hsObjectId = response.data.data.vid;
          }
        }).catch((e) => {});
        pushFindEmployeesEvent('saved search', {
          email: hashedEmail,
          hsObjectId: hsObjectId,
        });
        window.location.href = '/find-employees/subscribe-confirmation';
      }).catch((err) => {
        if (err.response?.data?.errors) {
          setErrors(err.response.data.errors);
        } else {
          setErrors({generalError: 'Subscribe.Form.GeneralError'});
        }
        setLoading(false);
      });
    };
    return (
      <>
        <div className="block block--subscribe bg-brand--white">
          <div className="py-l l:py-xl wrapper">
            <div className="l:flex">
              <div className="block__header">
                <h2 className="block__title">{intl.formatMessage({id: 'Subscribe.Form.TitleTop'})}</h2>
              </div>
              <div className="block__content">
                {fieldsTop}
              </div>
            </div>
            <div className="l:flex pt-l l:pt-xl">
              <div className="block__header">
                <h2 className="block__title">{intl.formatMessage({id: 'Subscribe.Form.TitleBottom'})}</h2>
              </div>
              <div className="block__content">
                {fieldsBottom}
                <div className="form-group">
                  <Button loading={loading} className="button button--full-width-to-icon button--filled button--m" onClick={submitSubscribe}>
                    <span className="button__text">{ intl.formatMessage({id: 'Subscribe.Form.SubmitButtonText'}) }</span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div>{renderForm()}</div>
  );
};

export default injectIntl(SubscribeForm);
